import CommonIndex from '@/views/CommonIndex.vue';
import { RouteComponent } from 'vue-router';

const router = {
  path: '/myproject',
  name: 'My Project',
  meta: {
    icon: 'imarketing-my-project',
    name: 'My Project',
    title: 'My Project',
    desc: 'My Project',
    level: 1,
    dir: true,
  },
  component: CommonIndex as unknown as RouteComponent,
  children: [
    {
      path: 'my_real_time_dashboard',
      meta: {
        name: 'My Real-Time Dashboard',
        icon: 'file-check-list',
        reportId: '01010101',
      },
      component: () => import('@/views/myproject/my-real-time-dashabaord/index.vue'),
    },
    {
      path: 'real-time',
      meta: {
        icon: 'compute-monitor',
        name: 'My Real-Time Dashboard / Real Time',
        reportId: '01010201',
        inNotInMenu: true,
        dir: true,
        hide: true,
        requiresAuth: false, // ✅ 添加此行，取消权限限制，允许所有人访问
      },
      component: () => import('@/views/myproject/realtime/index.vue'),
    },
  ],
};
export default router;
